module.exports = __webpack_public_path__ + "img/img-login-content.dafefee7.png";